
<val-boite-dialogue-generique #boiteDialogue
                              class="val-boite-dialogue-rg-date"
                              [titre]="titre"
                              (validerClick)="Valider()"
                              (annulerClick)="Annuler()">
  <div bandeau
       class="val-boite-dialogue-rg-date-bandeau">
    <val-simple-libelle [libelle]="bandeau"></val-simple-libelle>
  </div>
  <div contenu
       class="val-boite-dialogue-rg-date-contenu">
    <val-simple-panel>
      <div class="val-flex-conteneur">
        <kendo-datepicker calendarType="classic"
                          [(value)]="date">
        </kendo-datepicker>
      </div>
    </val-simple-panel>
  </div>

</val-boite-dialogue-generique>
